import { createFileRoute } from "@tanstack/react-router"
import { AuthenticatePage } from "@/pages/AuthenticatePage"

export const Route = createFileRoute("/authenticate")({
  component: AuthenticatePage,
})
